import {
  useEffect,
  type Dispatch,
  type MutableRefObject,
  type SetStateAction,
} from "react";
import type { History } from "history";
import getQueryVariable from "../functions/getQueryVariable";
import type { DataRequested, Dataset } from "../types/app.types";

type UseHistoryHandellerParams = {
  history: History;
  sliderValues: Array<number> | undefined;
  setSliderValues: (values: Array<number>) => void;
  dataRequested: DataRequested;
  setDataRequested: Dispatch<SetStateAction<DataRequested>>;
  setVersion: (version: string) => void;
  setContentToDisplay: (page: string) => void;
  setPageMode: (mode: boolean) => void;
  reqUpdateAddressBar: MutableRefObject<boolean>;
};

export const useHistoryHandeller = ({
  history,
  sliderValues,
  setSliderValues,
  dataRequested,
  setDataRequested,
  setVersion,
  setContentToDisplay,
  setPageMode,
  reqUpdateAddressBar,
}: UseHistoryHandellerParams) =>
  useEffect(() => {
    //Handles History
    return history.listen(() => {
      if (history.action === "POP") {
        const {
          sliderValues: sliderValuesFromHistory,
          country: countryFromHistory,
          year: yearFromHistory,
          version: versionFromHistory,
          page: pageFromHistory,
        } = getQueryVariable();

        const datasetFromHistory = window.location.pathname
          .slice(1)
          .toLowerCase();
        if (
          sliderValues !== sliderValuesFromHistory &&
          sliderValuesFromHistory
        ) {
          setSliderValues(sliderValuesFromHistory);
        }
        if (
          dataRequested.dataset !== datasetFromHistory ||
          dataRequested.year !== yearFromHistory ||
          dataRequested.country !== countryFromHistory
        ) {
          setDataRequested((prevState) => {
            return {
              // datasetFromHistory comes from the URL pathname (e.g. '/megs').
              dataset: (datasetFromHistory as Dataset) || prevState.dataset,
              year: yearFromHistory || prevState.year,
              country: countryFromHistory || prevState.country,
            };
          });
        }
        if (versionFromHistory) setVersion(versionFromHistory);
        if (pageFromHistory) setContentToDisplay(pageFromHistory);
        setPageMode(
          Boolean(
            pageFromHistory &&
              pageFromHistory !== "home" &&
              pageFromHistory !== "charts",
          ),
        );
        reqUpdateAddressBar.current = false;
      }
    });
  }, [
    dataRequested.country,
    dataRequested.dataset,
    dataRequested.year,
    history,
    reqUpdateAddressBar,
    setContentToDisplay,
    setDataRequested,
    setPageMode,
    setSliderValues,
    setVersion,
    sliderValues,
  ]);
